import * as React from "react";
import { observer } from "mobx-react";
import { API } from "General/API";
import { projectsDataStore } from "Stores/ProjectsStore";
import debounce from "debounce";
import { API_URL } from "General/APIEndpoints";
import { Spin } from "Components/General/Spin";
import { Form, FormInstance, Input, Select } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import DatePicker from "Components/General/DatePicker";

export interface MetaDataValueSelectProps extends WithTranslation {
  metadataName: string;
  metadataValue: string;
  metadataToShow: string;
  formRef: React.RefObject<FormInstance>;
}

interface MetaDataValueSelectState {
  metadataName: string;
  metadataValue: string | string[];
  data: API_Metadata[];
  loading: boolean;
}

export const MetaDataValueSelect = withTranslation([I18N_NS.PROJECT, I18N_NS.ADMIN])(
  observer(
    class extends React.Component<MetaDataValueSelectProps, MetaDataValueSelectState> {
      fetchDebounce;

      constructor(props: MetaDataValueSelectProps) {
        super(props);
        this.state = {
          metadataName: this.props.metadataName,
          metadataValue: this.props.metadataValue,
          data: [],
          loading: true,
        };
        this.fetchDebounce = debounce(this.fetch, 500);
      }

      componentDidMount() {
        this.fetchDebounce();
      }

      fetch = async () => {
        try {
          this.setState({ loading: true });

          const response = await API.getData<API_Metadata[]>(
            API_URL.METADATA.getDefinitionsFull(projectsDataStore.projectId)
          );

          this.setState({ loading: false, data: response });
        } catch (err) {
          throw err;
        }
      };
      handleNameSelect = (selectedKey: string) => {
        const { setFieldsValue } = this.props.formRef.current;

        setFieldsValue({ functionOptions: { plancheckMobileOptions: { qrFilterValue: [] } } });
        this.setState({ metadataName: selectedKey, metadataValue: "" });
      };

      getDecorator = (inputElem: React.ReactNode) => {
        let initialValue: string | string[] = this.state.metadataValue;
        if (initialValue === "*") {
          initialValue = "";
        }
        const selectedMetadata: API_Metadata = this.getSelectedMetaData();
        if (selectedMetadata?.rangeList && typeof initialValue === "string") {
          initialValue = initialValue.split(":");
          if (initialValue.length === 0 || (initialValue.length === 1 && initialValue[0] === "")) {
            initialValue = undefined;
          }
        }
        return (
          <Form.Item
            name={["functionOptions", "plancheckMobileOptions", "qrFilterValue"]}
            initialValue={initialValue}
            valuePropName="value"
          >
            {inputElem}
          </Form.Item>
        );
        // return getFieldDecorator("functionOptions.plancheckMobileOptions.qrFilterValue", {
        //   initialValue: initialValue,
        //   valuePropName: "value",
        // })(inputElem);
      };

      renderDT = () => {
        return this.getDecorator(<DatePicker format="DD.MM.YYYY" />);
      };

      renderRawText = (disabled?: boolean) => {
        return this.getDecorator(<Input disabled={disabled} style={{ width: "20%" }} />);
      };
      renderRange = () => {
        const selectedMetadata: API_Metadata = this.getSelectedMetaData();

        return this.getDecorator(
          <Select mode="tags" style={{ width: "20%" }} optionFilterProp="children">
            {selectedMetadata.rangeList.map((item, idx) => (
              <Select.Option key={idx} value={item.value}>
                {item.value + " - " + item.description}
              </Select.Option>
            ))}
          </Select>
        );
      };
      getSelectedMetaData = (): API_Metadata => {
        const { metadataName } = this.state;
        return this.state.data.find((e: API_Metadata) => {
          return e.key === metadataName;
        });
      };

      render() {
        const { t, metadataName, metadataToShow } = this.props;
        const { data, loading } = this.state;

        if (loading) return <Spin spinning={true} />;

        const renderers = {
          "*": this.renderRawText,
          W: this.renderRange,
          w: this.renderRange,
          DATE: this.renderDT,
        };
        const selectedMetadata = this.getSelectedMetaData();

        return (
          <>
            <Form.Item
              name={["functionOptions", "plancheckMobileOptions", "qrFilterMD"]}
              initialValue={metadataName}
              valuePropName="value"
            >
              <Select style={{ width: "20%" }} placeholder={t("Metadata")} onChange={this.handleNameSelect}>
                <Select.Option key="" value="">
                  {t("disabled")}
                </Select.Option>
                {data.map((item) => (
                  <Select.Option key={item.key} value={item.key}>
                    {item.key}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {selectedMetadata
              ? renderers[selectedMetadata.format]
                ? renderers[selectedMetadata.format]()
                : renderers["*"]()
              : renderers["*"](true)}
            <div>
              {t("Show value of this metadata when scanning QR code:")}
              <Form.Item
                name={["functionOptions", "plancheckMobileOptions", "qrMDtoShow"]}
                initialValue={metadataToShow}
                valuePropName="value"
              >
                <Select style={{ width: "20%" }}>
                  <Select.Option key="" value="">
                    {t("disabled")}
                  </Select.Option>
                  {data.map((item) => (
                    <Select.Option key={item.key} value={item.key}>
                      {item.key}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </>
        );
      }
    }
  )
);
